import React from "react";

const DropdownBox = () => {
    return <div id="dropdown-root"></div>
};

export default DropdownBox;